import gql from "graphql-tag";
const DELETE_EMAILS_TEMPLATES = gql `
  mutation deleteEmailsTemplate($id: ID!) {
    deleteEmailsTemplate(id: $id) {
      status
    }
  }
`;
export default DELETE_EMAILS_TEMPLATES;
